import { isAvailable, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse;

export const MIXED_SUBURBAN_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'price',
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'landStatus',
      'constructionType',
      'suburbanHouseType',
      'suburbanBathroom',
      'suburbanUtilities',
      'heatingType',
      'suburbanFloors',
      'bedrooms',
      'constructionYear',
      'suburbanFacilities',
      'offerSeller',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'price',
      'withNeighbors',
      'rentalPeriod',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'facilities',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'bedrooms',
      'constructionType',
      'heatingType',
      'constructionYear',
      'rentTerms',
      'livingConditions',
      'publicationDate',
      'isOwner',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
